jQuery(document).ready(function ($) {

  const form  = $('#movida-form');
  const cepField = $('.cep');
  const documentField = $('.cnpj');
  const phoneField = $('.phone');

  formValidateConfig(form);

  maskCep(cepField);
  maskPhone(phoneField);
  maskCnpj(documentField);

  validatorCep();
  validatorCnpj();
  validatorPhone();

  $(form).submit(function (e) {
    e.preventDefault();


    if ($(this).valid()) {
      const formRaw  = document.forms.movida;
      const formData = new FormData(formRaw);
      const offer    = $('#form-offer-id').val();

      const submitButton = $(form).find('button[type="submit"]');
      var btnSubmitText = submitButton.text();

      grecaptcha.enterprise.ready(function() {
        grecaptcha.enterprise.execute(ajaxHandler.siteKey, {action: 'save_lead'}).then(function (grecaptchaToken) {

          $.ajax({
            url: ajaxHandler.url,
            type: 'POST',
            data: {
              action: 'jc_ajax_offer_save_lead_movida',
              context: window.location.href.includes('patrocinado')? 'landing-page' : 'lead',
              title: $(document).prop("title"),
              offer: offer,
              name: formData.get('name'),
              email: formData.get('email'),
              phone: formData.get('phone'),
              cep: formData.get('cep'),
              document: formData.get('cnpj'),
              realName: formData.get('razaosocial'),
              numberVehicles: formData.get('qtdveiculos'),
              getParameters: encodeURIComponent(JSON.stringify(getUrlVars())),
              lgpd: [
                {
                  lgpd: true,
                  text_disclaimer: $(form).find('input[name="lgpd"]').parents(".form-group").text().trim(),
                  url_disclaimer:  $(form).find('input[name="lgpd"]').parents(".form-group").find('a').map(function(){return $(this).prop('href');}).get()
                }
              ],
              optIn: {
                estadao: formData.get('estadao') === 'on'
              },
              url_page: window.location.href,
              token: grecaptchaToken
            },
            beforeSend: function () {
              $(submitButton).prop('disabled', true).html('<i class="fa fa-cog fa-spin fa-fw"></i> Enviando...');
            },
            success: function (response) {

              if (response && response.success) {
                var leadID = response.data.leadID;
                setLeadIdSessionStorage(leadID);
                send_offer_lead_success_events(offer, leadID, 'Oferta');
                gtm_get_data_and_send_lead_saved(leadID, 'landingPage')
                  .then(function () {

                    const formHeader    = $('#form-header-text');
                    const formSubHeader = $('#form-subheader-text');

                    if (formHeader.length && formSubHeader.length) {
                      form.slideUp();
                      formHeader.text('Obrigado!');
                      formSubHeader.text('Em breve você receberá um contato para conversar sobre as condições comerciais que possibilitem o fechamento do negócio.');
                    } else {
                      if(window.location.pathname.indexOf("oferta") > -1) {
                        window.location.href += ((window.location.href.indexOf("?") > -1 ? '&' : '?') + 'pagina=obrigado&id=' + leadID);
                      }
                      else {
                        window.location.href = '/patrocinado/movida-obrigado/'+window.location.search;                        ;
                      }
                    }
                  });
              } else {
                send_offer_lead_error_events();
                populateAndShowFormError(form, response.data);
                submitButton.prop('disabled', false).html(btnSubmitText);
              }
            }
          });

          $.ajax({
            url: ajaxHandler.url_leads + '/api/jornaldocarro/v1/receive-callback-movida',
            type: 'POST',
            data: {
              action: 'jc_ajax_offer_save_lead_movida',
              context: window.location.href.includes('patrocinado')? 'landing-page' : 'lead',
              title: $(document).prop("title"),
              offer: offer,
              name: formData.get('name'),
              email: formData.get('email'),
              phone: formData.get('phone'),
              cep: formData.get('cep'),
              document: formData.get('cnpj'),
              realName: formData.get('razaosocial'),
              numberVehicles: formData.get('qtdveiculos'),
              getParameters: encodeURIComponent(JSON.stringify(getUrlVars())),
              lgpd: [
                {
                  lgpd: true,
                  text_disclaimer: $(form).find('input[name="lgpd"]').parents(".form-group").text().trim(),
                  url_disclaimer:  $(form).find('input[name="lgpd"]').parents(".form-group").find('a').map(function(){return $(this).prop('href');}).get()
                }
              ],
              optIn: {
                estadao: formData.get('estadao') === 'on'
              },
              url_page: window.location.href,
              token: grecaptchaToken
            },
            success: function (response) {
              if (response && response.success) {
               console.log('Lead enviado para o novo sistema');
              } else {
                console.log('Erro ao enviar lead para o novo sistema');
              }
            }
          });
        });
      });
    }
  });



});
